import { Component, ViewChild } from '@angular/core';
import { FeatureCollection, Polygon, MultiPolygon, Feature, Point } from '@turf/helpers';
import { Subscription, take } from 'rxjs';
import { GeocoderComponent } from 'src/app/features/map-features/ui/organisms/geocoder/components/geocoder/geocoder.component';
import { UnileverAPIService } from 'src/app/features/shared/services/API/UnileverAPI.service';
import { MapHelperService } from 'src/services/map-helper.service';
import { FrecuencyZonesMapSectionService } from '../../../../services/frecuencyZones-section.service';

@Component({
  selector: 'frecuency-zones-section',
  templateUrl: './frecuency-zones-section.component.html',
  styleUrls: ['./frecuency-zones-section.component.css'],
})
export class FrecuencyZonesSectionComponent {

  @ViewChild('frecuencyGeocoder') geocoderComponent: GeocoderComponent;

  isLoading: boolean = true;

  searchAddress: string = '';
  isMapSelectionActive: boolean = false;
  mapClickHandler: any = null;
  isGeocoderReady: boolean = false;
  isDropdownVisible: boolean = false;

  closestFeature: any = null;

  // Puntos de frecuencia
  frequencyPoints: { properties: { [key: string]: any }, coordinates: [number, number], nombre: string }[] = [];
  selectedPoint: { lng: number, lat: number } = null;

  subscription_getFrecuencyData: Subscription;
  subscription_isVisible: Subscription;

  hasInitialized: boolean = false;

  constructor(
    private mapHelperService: MapHelperService,
    public frecuencyZonesMapSectionService: FrecuencyZonesMapSectionService,
    private unileverService: UnileverAPIService
  ) { 
    
    this.subscription_isVisible = this.frecuencyZonesMapSectionService.isVisible.asObservable().subscribe( isVisible => {
      if(isVisible){
        this.initializeComponent();
      } else if (this.hasInitialized) {
        console.log("selector visible", isVisible);
        this.reset();
      }
    });
  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    this.frecuencyZonesMapSectionService.setIsFrecuencyZonesVisible(false);
    this.reset();

    this.subscription_isVisible?.unsubscribe();
  }

  toggleMapSelection(): void {
    this.isMapSelectionActive = !this.isMapSelectionActive;

    if (this.isMapSelectionActive) {
      this.addClickEvent();
    } else {
      this.removeClickEvent();
    }
  }

  addClickEvent(){
    this.mapClickHandler = (e: any) => {
      const { lng, lat } = e.lngLat;

      this.searchAddress = lat.toFixed(6) + "," + lng.toFixed(6);
      this.isLoading = true;
        
      this.isMapSelectionActive = false;
      if (this.mapClickHandler) {
        this.mapHelperService.RemoveEventFromMap('click', this.mapClickHandler);
        this.mapHelperService.isPointPickingActive = false;
        this.mapClickHandler = null;
      }
      this.mapHelperService._map.getCanvas().style.cursor = '';
        
      // this.onPointSelected({ lng, lat });
      // this.mapHelperService.FlyToCameraFast(lat, lng, '14', 0);
      setTimeout(() => {
        this.search();
      }, 500);
    };
    this.mapHelperService.isPointPickingActive = true;
    this.mapHelperService.addEventOnMap('click', this.mapClickHandler);
    this.mapHelperService._map.getCanvas().style.cursor = 'crosshair';
  }

  removeClickEvent(){
    if (this.mapClickHandler) {
      this.mapHelperService.RemoveEventFromMap('click', this.mapClickHandler);
      this.mapHelperService.isPointPickingActive = false;
      this.mapClickHandler = null;
      this.mapHelperService._map.getCanvas().style.cursor = '';
    }
  }

  async initializeComponent(): Promise<void> {
    this.isLoading = true;
    await this.frecuencyZonesMapSectionService.loadLayers();
    this.hasInitialized = true;
    if(this.isGeocoderReady)
      this.isLoading = false;

    this.mapHelperService.mapResize();
    // this.potentialZonesMapSectionService.initializePotentialZonesMapSection();
  }

  onPointSelected(point: { lng: number, lat: number }): void {
    console.log('Punto seleccionado:', point);
    this.selectedPoint = point;
    this.loadFrequencyPointsData(point);
  }

  onDropdownVisibilityChange(isVisible: boolean): void {
    this.isDropdownVisible = isVisible;
  }

  private loadFrequencyPointsData(selectedPoint: { lng: number, lat: number }): void {
    const centerLng = this.selectedPoint ? this.selectedPoint.lng : -98.884194;
    const centerLat = this.selectedPoint ? this.selectedPoint.lat : 19.502903;
    this.isLoading = true;

    this.subscription_getFrecuencyData = this.unileverService.GetNearestRouteFrecuencyByCoordsUI(centerLat.toString(), centerLng.toString()).pipe(take(1)).subscribe( 
      {
        next: async (response: any) => {
          //response.result && response.result.listLocationsNearest && response.result.layerNearestPointsGeojson
          if(response.result && response.result.listLocationsNearest && response.result.layerNearestPointsGeojson){
            const result = response.result;
            const nearestsLocations = result.listLocationsNearest;
            const nearestLocationIdentifier = nearestsLocations && nearestsLocations.length > 0 ? nearestsLocations[0].identifier : null;

            if(nearestLocationIdentifier){
              //se obtiene la más cercana y sis valores
              const nearestLocationProperties = nearestsLocations.filter(loc => loc.identifier === nearestLocationIdentifier);

              const frecuencyProperties = nearestLocationProperties.reduce((acumulado, actual) => {
                acumulado[actual.key] = actual.value;
                return acumulado;
              }, {} as { [key: string]: any });

              // se procesa el geojson y se sacan los features únicos
              const geoJsonData = JSON.parse(result.layerNearestPointsGeojson) as FeatureCollection<Point>;
              
              const uniqueFeatures = Array.from(
                new Map(geoJsonData.features.map(feature => [feature.properties.Identifier, feature])).values()
              );
              geoJsonData.features = uniqueFeatures;
              geoJsonData.features.forEach(feature => {
                feature.properties.icon = 'bussineLocation.png';
                feature.properties.activeIcon = 'bussineLocationA.png';
              });

              //se obtiene el feature más cercano y se arma el que se usa para mostrar
              this.closestFeature = geoJsonData.features.find(feature => feature.properties.Identifier === nearestLocationIdentifier);
              if(this.closestFeature.geometry != null && this.closestFeature.geometry.coordinates)
                // this.frecuencyZonesMapSectionService.openPopUp(this.closestFeature.properties.Identifier, this.closestFeature.geometry.coordinates);

              console.log("frecuencia 1", this.closestFeature, frecuencyProperties);

              this.frequencyPoints =[{
                properties: { ...frecuencyProperties },
                nombre: this.closestFeature.properties?.Identifier,
                coordinates: this.closestFeature.geometry?.coordinates as [number, number]
              }];

              console.log("frecuencia 2", this.frequencyPoints);
          
              if (geoJsonData.features.every(feature => feature.geometry != null && feature.geometry.coordinates != null)) {
                this.frecuencyZonesMapSectionService.loadGeoJson(geoJsonData);
              }
              this.isLoading = false;
            }else{
              this.frequencyPoints = [];
              this.isLoading = false;
            }
           
          }else{
            this.frequencyPoints = [];
            this.isLoading = false;
          }
        },
        error: (error) => {
          console.error('Error al obtener los datos de frecuencia de ruta:', error);
          this.frequencyPoints = [];
          this.isLoading = false;
        }
    });
  }

  search(){
    if (this.geocoderComponent) {
      this.searchAddress = this.searchAddress.trim();
      this.geocoderComponent.searchLocationConPlaces(true);
      this.removeClickEvent();
      this.isMapSelectionActive = false;
    }
  }

  reset(){
    this.frecuencyZonesMapSectionService.destroyLayers();
    this.frequencyPoints = [];
    this.selectedPoint = null;
    this.removeClickEvent();
    this.isMapSelectionActive = false;
    this.searchAddress = '';
    this.geocoderComponent?.clearSearch();
  }

  onGeocoderReady(isReady: boolean){
    this.isGeocoderReady = isReady;
    this.isLoading = false;
    this.addClickEvent();
    this.isMapSelectionActive = true;
  }

  openPopUp(){
    if(this.closestFeature){
      // this.frecuencyZonesMapSectionService.openPopUp("30613387", [19.287548,-98.449921]);
      this.frecuencyZonesMapSectionService.openPopUp(this.closestFeature.properties.Identifier, this.closestFeature.geometry.coordinates);
    }
  }
}
